<template>
  <div class="basic-container">
      <navbar />
      <div class="basic-main">
          <router-view />
      </div>
      <y-footer />
  </div>
</template>

<script>
import navbar from './components/navbar.vue'
import yFooter from '../../components/yFooter.vue'
export default {
    components: {
        navbar, yFooter
    }
}
</script>

<style lang="scss" scoped>
.basic-container {
    display: flex;
    flex-direction: column;
    flex: auto;
    min-height: 100vh;
    .basic-main {
        flex: auto;
    }
}
</style>